// roleCheckMixin.js
import VueCookies from "vue-cookies";


export default {
  data() {
    return {
      loggedInRole: null,
    };
  },
  methods: {
    checkUserRole(role) {
      if (this.loggedInRole !== role) {
        alert(
          "Vous devez être administrateur pour accéder à cette page."
        );
        this.$router.push("/"); // Rediriger vers la page d'accueil ou une autre page appropriée
      }
    },
  },
  created() {
    const role = VueCookies.get("role");
    if (role) {
      this.loggedInRole = role;
    }
    this.checkUserRole("admin"); // Remplacez 'admin' par le rôle requis pour accéder à cette page
  },
};